<main class="container py-5 my-5">
  <div class="row align-items-center">
    <div class="col-md-6 text-center">
      <img src="assets/img/bedankt.png" class="thank-img rounded-5">
    </div>
    <div class="col-md-6 text-center">
      <h1 class="m-auto fw-bold thank-title">Bedankt voor je bijdrage!</h1>
      <p class="m-auto thank-description mt-3">Je activiteit is succesvol geplaatst en is nu zichtbaar voor gebruikers van Steddie.nl!</p>
      <div>
        <button class="btn btn-primary thank-button mt-3 purple" [routerLink]="['/activiteit', eventID]">Bekijk activiteit</button>
      </div>
    </div>
  </div>
  <div class="text-center pt-5 w-auto thanks-lower">
    <p class="mt-3">Wil je nog een activiteit toevoegen of jouw geplaatste activiteiten beheren? Ga dan naar jouw dashboard.</p>
    <button class="btn btn-primary thank-button purple mt-3" [routerLink]="['/activiteit/aanmaken']">
      Voeg nog een activiteit toe
    </button>
    <button class="btn btn-primary thank-button beige mt-3" [routerLink]="['/mijn-organisatie/activiteiten']">
      Ga naar mijn dashboard
    </button>
  </div>
</main>
